import { useEffect, useState } from 'react';
import axios from 'axios';

const CommonSelect09 = ({ searchParams, handleInputChange, flag, setDesc }) => {

    const today = new Date();
    const currentYear = today.getFullYear();
    const firstDay = new Date(searchParams.searchYear, searchParams.searchCheck2, 1).getDate();
    const lastDay = new Date(searchParams.searchYear, searchParams.searchCheck2, 0).getDate();
    const [emogList, setEmogList] = useState([]);
    const apiUrl = flag ? '/trmsapi/obthrc/newHospList.do' : '/ptmiapi/trmsEmogList.do';

    const fetchInitialData = async () => {
        try {
            const response = await axios.get(apiUrl, {
                params: {
                    grdc: "Y",
                    loca: ""
                }
            });
            setEmogList(response.data.emogList || response.data);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };

    useEffect(() => {
        fetchInitialData();
    }, []);

    useEffect(() => {
        const desc = flag ? emogList.find((a) => a.EMOGCODE === searchParams.searchEmog)?.EMOGDESC : emogList.find((a) => a.emogcode === searchParams.searchEmog)?.emogdesc;
        setDesc(desc);
    }, [searchParams.searchEmog]);

    return (
        <tr>
            <th>{!flag ? "조회년월" : "조회시작일"}</th>
            <td>
                {!flag ? <>
                    <select id="searchYear"
                        name="searchYear"
                        value={searchParams.searchYear}
                        onChange={handleInputChange}
                    >
                        {Array.from({ length: 11 }, (_, i) => {
                            const year = (currentYear +1 - i).toString()
                            return (
                                <option key={year} value={year}>
                                    {year}년
                                </option>
                            );
                        })}
                    </select>
                    &nbsp;
                    <select id="searchCheck2"
                        name="searchCheck2"
                        value={searchParams.searchCheck2}
                        onChange={handleInputChange}
                    >
                        {Array.from({ length: 12 }, (_, i) => {
                            const month = (i + 1).toString().padStart(2, '0');
                            return (
                                <option key={month} value={month}>
                                    {month}월
                                </option>
                            );
                        })}
                    </select>
                </>
                    :
                    <input
                        type="date"
                        name="searchFromdate"
                        value={searchParams.searchFromdate}
                        onChange={handleInputChange}
                    />
                }
            </td>
            <th>{!flag ? "기준일자" : "조회종료일"}</th>
            <td>
                {!flag ? <>
                    <select
                        id="searchFromdate"
                        name="searchFromdate"
                        value={searchParams.searchFromdate}
                        onChange={handleInputChange}
                        disabled={searchParams.searchGubun === 'N'}
                    >
                        {Array.from({ length: lastDay - firstDay + 1 }, (_, i) => {
                            const day = (firstDay + i).toString().padStart(2, '0');
                            return (
                                <option key={day} value={day}>
                                    {day}
                                </option>
                            );
                        })}
                    </select>
                    &nbsp;&nbsp;&nbsp;
                    <span>
                        <input type="checkbox" id="searchGubun" name="searchGubun" checked={searchParams.searchGubun === 'Y'} onChange={handleInputChange} />
                        <label htmlFor="searchGubun">기준 적용일</label>
                    </span></> :
                    <input
                        type="date"
                        name="searchTodate"
                        value={searchParams.searchTodate}
                        onChange={handleInputChange}
                    />
                }
            </td>
            <th>의료기관명</th>
            <td>
                <select
                    name='searchEmog'
                    className='w-full'
                    value={searchParams.searchEmog}
                    onChange={handleInputChange}
                >
                    <option value={""}>전체</option>
                    {flag ?
                        emogList.map(hosp => (
                            <option key={hosp.EMOGCODE} value={hosp.EMOGCODE}>{hosp.EMOGDESC}</option>
                        ))
                        : emogList.map(hosp => (
                            <option key={hosp.emogcode} value={hosp.emogcode}>{hosp.emogdesc}</option>
                        ))
                    }
                </select>
            </td>
        </tr>
    );
};

export default CommonSelect09; 